<template>
    <div class="adviser">
        <ul class="orderList" >
        <li class="item m-b-20" v-for="(item, index) in dataList" :key="index" @click.stop="viewContract(item)">
                <div class="title brder-b flex-row">
                    <p class="orderNumber">合同号：{{item.contractNo}}</p>
                    <div class="orderStats" v-if="status == 0">
                        <span @click="viewContract(item)">签 订</span>
                    </div>
                </div>
                <div class="product m-t-25">品牌：{{item.brandName}}</div>
                <div class="product m-t-25">签字日期：{{item.confirmTime}}</div>
                <div class="product m-t-25">预计验收时间：{{item.acceptanceTime}}</div>
                <div class="product m-t-25">其他约定事项：{{item.covenants}}</div>
            </li>
        </ul>    
    </div>
</template>
<script>
import { listServiceBill,getServiceBillPDF } from '@/api/index';
import logo  from '@/assets/img/lion.jpg';
import tel  from '@/assets/img/tel.png';
export default {
    data(){
        return{
            dataList: [],
            logo,
            tel,
            status: this.$route.query.status || 0
        }
    },
    created(){
        this.getData();
    },
    methods:{
        getData(){
            let data = this.$loca.getItem('phone');
            let query = {
                customerPhone:  data,
                status: this.status
            }
            listServiceBill(query).then(res=>{
                res.data.map(item=>{
                    item.confirmTime = (item.confirmTime && item.confirmTime.substring(0,10)) || '';
                    item.acceptanceTime = (item.acceptanceTime && item.acceptanceTime.substring(0,10)) || '';
                })
                this.dataList = res.data;
            }).catch(error=>{

            })
        },
        viewPhone(item){
             window.location.href = 'tel://' + item;
        },
        viewContract(item) {
            getServiceBillPDF({ serviceBillId: item.serviceBillId }).then(res=>{
                this.$router.push({
                    path: '/servicedetail',
                    query: {
                        pdfUrl: res.message,
                        serviceBillId:item.serviceBillId,
                        status: this.status
                    }
                });
            })

        }        
    }
}
</script>
<style lang="scss" scoped>
    .adviser{
        background: #ededed;
        .orderList{
            background: $color-ed;
            .item{
                // height: 334px;
                background: $ffff;
                padding: 0 20px;
                padding-bottom: 10px;
                .title{
                    padding: 18px 0 15px 0; 
                    justify-content: space-between;
                    .orderNumber{
                        font-size:28px;
                        color:rgba(51,51,51,1);
                        margin-left: 18px;
                    }
                    .orderStats{
                        font-size:20px;
                        color:rgba(86,180,240,1);
                        margin-right: 11px;
                        span{
                            margin-left: 15px;
                        }
                    }
                }
                .product{
                    padding-left: 14px;
                    font-size:24px;
                    color: $color-102;
                    justify-content: space-between;
                    align-items: center;
                    .time{
                        margin-right: 11px;
                        font-size:20px;
                        color:$color-187;
                    }
                    .numbers{
                        font-size:24px;
                        color:$color-81;
                    }
                    .invoice{
                        margin-right: 11px;
                        font-size:20px;
                        color:$color-153;
                    }
                }
                .products{
                    margin-left: 14px;
                    font-size:24px;
                    color: $color-102;
                    align-items: center;
                    position: relative;
                    .time{
                        margin-right: 11px;
                        font-size:20px;
                        color:$color-187;
                    }
                    .numbers{
                        font-size:24px;
                        color:$color-81;
                    }
                    .invoice{
                        margin-right: 11px;
                        font-size:20px;
                        position: absolute;
                        left: 350px;
                    }
                }
                .info{
                    padding: 16px 0 10px 0;
                    font-size:24px;
                    color:$color-153;
                    width: auto;
                    align-items: center;
                    justify-content: space-between;
                    img{
                        width: 54px;
                        height: 54px;
                    }
                    .information{
                        align-items:center;
                        .names{
                            margin-bottom: 7px;
                        }
                        img{
                            width: 65px;
                            height: 65px;
                            margin: 0 25px 0 21px;
                        }
                    }
                }
            }
        }
    }
</style>